import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
} from "reactstrap";
import LoadingIndicator from '../../utils/LoadingIndicator';
import {
    AppAside,
    AppBreadcrumb,
    AppFooter,
    AppHeader,
    AppSidebar,
    AppSidebarFooter,
    AppSidebarForm,
    AppSidebarHeader,
    AppSidebarMinimizer,
    AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import {ajaxWrapperGet, getSystemUserInformation} from "../../utils/deviceAPI";
import AuthService from "../../components/AuthService";
import AnnunciatorSystem from "../../views/site/Annunciator/System";
import Help from "../../views/Help/Help";
import VerifyPhone from "../../views/Userconfig/VerifyPhone";
import Overview from "../../views/site/Overview";
import Control from "../../views/site/Control/Control";
import Developer from "../../views/site/Developer/Developer";
import DeveloperOverview from "../../views/site/Developer/DeveloperOverview";
import DeveloperControl from "../../views/site/Developer/DeveloperControl";
import Siteusers from "../../views/site/Users/Users";
import Configuration from "../../views/site/Configuration/Configuration";
import Users from "../../views/Admin/Users/Users";
import Account from "../../components/Account/Account";
import Alarms from "../../views/site/Alarms/Alarms";
import Historical from "../../views/site/Historical/Historical";
import DeviceInformation from "../../views/site/information/DeviceInformation";
import Siteinvitations from "../../views/Invitations/Siteinvitations";
import Accountinvitations from "../../views/Invitations/Accountinvitations";
import Dashboard from "../../views/Dashboard";
import Map from "../../views/Dashboard/Map";



const renderMergedProps = (component, ...rest) => {
    const finalProps = Object.assign({}, ...rest);
    return (
        React.createElement(component, finalProps)
    );
};

const PropsRoute = ({ component, ...rest }) => {
    return (
        <Route {...rest} render={routeProps => {
            return renderMergedProps(component, routeProps, rest);
        }}/>
    );
};

class DefaultLayout extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [
                {

                    initializer: 0
                },
                {
                    initializer: 0
                }
            ],
            loading: true,
            notifications: {
                notifications: 0
            },
            siteInfo: [
                {
                    alarms:[]
                }
            ],
            devicestatus: 0,
            siteAlarmPresent: false,
            preferredSite: "Dashboard",
            preferredSiteValue: "Dashboard"

        };
        this.Auth = new AuthService();
    }

    pageSwitch() {
        if (!this.state.loading) {
            this.Auth.refreshToken();
        }

    }

    componentDidMount() {
        getSystemUserInformation().then((navBarFromServer) => {


            let preferredSite = "Dashboard";
            if (navBarFromServer.preferredSite !== "Dashboard") {
                let navBarSplit = navBarFromServer.preferredSite.split('/');
                for (let string = 0; string < navBarSplit.length; string++) {
                    if (navBarSplit[string].includes('device_')) {
                        preferredSite = navBarSplit[string].split('_')[1];
                    }
                }
            }
            this.setState({
                navBarFromServer: navBarFromServer.navBar,
                preferredSite: navBarFromServer.preferredSite,
                preferredSiteValue: preferredSite,
                routes: this.routeBuilder(navBarFromServer.navBar.items),
                loading: false

            });

            this.tick();
            this.timerID = setInterval(
                () => this.tick(),
                20000
            );

        }).catch((error) => {
            //localStorage.removeItem('id_token');
            this.props.history.replace('/500');
        });
    }

    componentWillUnmount(){
        clearInterval(this.timerID);
    }

    reloadNavBar() {
        getSystemUserInformation().then((navBarFromServer) => {
            this.setState({
                navBarFromServer,
                routes: this.routeBuilder(navBarFromServer.items),
                loading: false
            });
            this.tick();
        });
    }

    routeBuilder(items) {
        let routes = [];
        for (let path = 0; path < items.length; path++) {
            if (items[path].title) {}
            else {
                if (items[path].children === undefined) routes.push({
                    path: items[path].url,
                    name: items[path].name });
                else {
                    for (let child = 0; child < items[path].children.length; child ++) {
                        if (items[path].children[child].children === undefined) routes.push({
                            path: items[path].children[child].url,
                            name: `${items[path].name} / ${items[path].children[child].name}` });
                        else {
                            for (let grandChild = 0; grandChild < items[path].children[child].children.length; grandChild ++) {
                                routes.push({
                                    path: items[path].children[child].children[grandChild].url,
                                    name: `${items[path].name} / ${items[path].children[child].name} / ${items[path].children[child].children[grandChild].name}` });
                            }
                        }
                    }
                }
            }
        }
        return routes;
    }

    tick() {
        ajaxWrapperGet('/api/user/dashboardData').then((siteInfo) => {
            if (siteInfo !== undefined) this.setState({
                siteInfo
            });

        });
    }

    goToSite(siteUrl) {
        this.props.history.replace(siteUrl);
    }

    redirectRoutePreferredSite(url) {
        return url === "Dashboard" ? "/dashboard" : url;
    }

    render() {

        if (this.state.loading || (this.state.navBarFromServer === undefined)) {
            return <LoadingIndicator />;
        }
        let { navBarFromServer } = this.state;
        let { siteInfo } = this.state;

        if (siteInfo !== undefined) {
            if (siteInfo.alarms !== undefined) {
                for (let x = 0; x < siteInfo.alarms.length; x++) {

                    for (let i = 0; i < navBarFromServer.items.length; i++) {
                        if (navBarFromServer.items[i]['name'] === siteInfo.alarms[x]['siteName']) {
                            if (siteInfo.alarms[x]['online'] === 1) {
                                navBarFromServer.items[i]['icon'] = "fa fa-globe text-success"
                            }
                            else if (siteInfo.alarms[x]['online'] === 0) {
                                navBarFromServer.items[i]['icon'] = "fa fa-globe text-danger"
                            }
                            else {
                                navBarFromServer.items[i]['icon'] = "fa fa-globe text-secondary"
                            }
                        }
                    }

                    if (siteInfo.alarms[x]['alarm'] === 1) {
                        for (let i = 0; i < navBarFromServer.items.length; i++) {
                            if (navBarFromServer.items[i]['name'] === siteInfo.alarms[x]['siteName']) {
                                //loop through children
                                for (let t = 0; t < navBarFromServer.items[i]['children'].length; t++) {
                                    if (navBarFromServer.items[i]['children'][t]['name'] === "Alarms") {
                                        navBarFromServer.items[i]['children'][t]['badge'] = {
                                            variant: 'danger',
                                            text: 'ALM'
                                        };
                                    }
                                }
                            }
                        }
                    }
                    else if (siteInfo.alarms[x]['alarm'] === 0) {
                        for (let i = 0; i < navBarFromServer.items.length; i++) {
                            if (navBarFromServer.items[i]['name'] === siteInfo.alarms[x]['siteName']) {
                                //loop through children
                                for (let t = 0; t < navBarFromServer.items[i]['children'].length; t++) {
                                    if (navBarFromServer.items[i]['children'][t]['name'] === "Alarms") {
                                        navBarFromServer.items[i]['children'][t]['badge'] = {};
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return (
            <div className="app">
                <AppHeader>
                    <DefaultHeader {...this.props}/>
                </AppHeader>
                <div className="app-body">
                    <AppSidebar display="lg" >
                        <AppSidebarHeader />
                        <AppSidebarForm />
                        <AppSidebarNav navConfig={navBarFromServer} {...this.props} />
                        <AppSidebarFooter />
                        <AppSidebarMinimizer />
                    </AppSidebar>
                    <main className="main">
                        <Container fluid className="pt-3">
                            <Row>
                                <Col xs="12" lg="12">
                                    <Card>
                                        <CardBody className="card-body p-0 breadcrumb-card">
                                            <AppBreadcrumb appRoutes={this.state.routes}/>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                        <Container fluid>
                            <Switch onEnter={this.pageSwitch()}>
                                <PropsRoute path="/dashboard" name="Dashboard" component={Dashboard} uidata={this.state.siteInfo} goToSite={(siteUrl) => this.goToSite(siteUrl)} reloadNavBar={() => this.reloadNavBar()}/>
                                <PropsRoute path="/site/overview/:dev/:site" name="Overview" component={Overview} uidata={this.state.siteInfo}/>
                                <PropsRoute path="/site/alarms/:dev/:site" name="Alarms" component={Alarms} uidata={this.state.siteInfo}/>
                                <PropsRoute path="/site/historical/:dev/:site" name="Historical" component={Historical} uidata={this.state.siteInfo}/>
                                <PropsRoute path="/site/control/:dev/:site" name="Control" component={Control} uidata={this.state.siteInfo}/>
                                <PropsRoute path="/site/information/:dev/:site" name="Information" component={DeviceInformation} uidata={this.state.siteInfo}/>
                                <PropsRoute path="/site/users/:dev/:site" name="Users" component={Siteusers}/>
                                <PropsRoute path="/invitations/site" name="Site Invitations" component={Siteinvitations}/>
                                <PropsRoute path="/invitations/account" name="Account Invitations" component={Accountinvitations}/>
                                <Route path="/site/configuration/:dev/:site" name="Configuration" component={Configuration} />
                                <Route path="/site/developer/:dev/:site" name="Developer" component={Developer} />
                                <Route path="/site/developeroverview/:dev/:site" name="Developer Overview" component={DeveloperOverview} />
                                <Route path="/site/developercontrol/:dev/:site" name="Developer Control" component={DeveloperControl} />
                                <PropsRoute path="/account" name="Account" component={Account} uidata={this.state.siteInfo} preferredSite={this.state.preferredSiteValue} goToSite={(siteUrl) => this.goToSite(siteUrl)} reloadNavBar={() => this.reloadNavBar()}/>
                                <Route path="/verify" name="Verify Phone" component={VerifyPhone}/>
                                <Route path="/help" name="Help" component={Help}/>
                                <Redirect from="/" to={this.redirectRoutePreferredSite(this.state.preferredSite)}/>
                            </Switch>
                        </Container>
                    </main>
                    <AppAside fixed hidden>
                        <DefaultAside />
                    </AppAside>
                </div>
                <AppFooter>
                    <DefaultFooter />
                </AppFooter>
            </div>
        );
    }
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js